module.exports = __webpack_public_path__ + "img/number_3.2f823ee4.svg";